import { v4 as uuidv4 } from "uuid";
import api from "./api";

// 1s, 3s, 6s: cobre a queda curta de rede sem deixar o atendente esperando.
const ESPERAS = [1000, 3000, 6000];

// Sem `response` a requisição não obteve resposta do servidor — DNS que não
// resolveu, máquina offline, conexão cortada. Erro de negócio (400, 401, 500)
// tem `response` e não deve ser repetido.
export const isErroDeTransporte = err => Boolean(err) && !err.response;

const espera = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Envia a mensagem repetindo apenas quando a falha foi de transporte.
 *
 * Como não dá para saber se a tentativa anterior chegou a ser processada, cada
 * envio leva um clientId e o backend (helpers/MessageIdempotency) recusa a
 * repetição — sem isso, reenviar duplicaria a mensagem para o cliente.
 */
export const sendMessageWithRetry = async (url, payload) => {
  const clientId = uuidv4();
  let corpo;

  if (payload instanceof FormData) {
    payload.append("clientId", clientId);
    corpo = payload;
  } else {
    corpo = { ...payload, clientId };
  }

  let ultimoErro;

  for (let tentativa = 0; tentativa <= ESPERAS.length; tentativa += 1) {
    try {
      return await api.post(url, corpo);
    } catch (err) {
      ultimoErro = err;

      if (!isErroDeTransporte(err) || tentativa === ESPERAS.length) {
        throw err;
      }

      await espera(ESPERAS[tentativa]);
    }
  }

  throw ultimoErro;
};
